
import React, { useMemo } from "react";
import DataTable from "react-data-table-component";
import { Button } from "react-bootstrap";
import FilterComponent from "./FilterComponent";
import { format } from 'date-fns'; // 使用date-fns库进行日期格式化


const PosTable = props => {

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return format(date, 'yyyy-MM-dd');
  };


  const columns = [
    {
      name: <strong style={{ fontSize: '18px', textAlign: "center", width: "100%" }}>PO#</strong>,
      selector: row => <div style={{ textAlign: "center" }}>{row.number ?? ""}</div>,
    },
    {
      name: <strong style={{ fontSize: '18px', textAlign: "center", width: "100%" }}>site</strong>,
      selector: row => <div style={{ textAlign: "center" }}>{row.factory_name ?? ""}</div>,
    },
    {
      name: <strong style={{ fontSize: '18px', textAlign: "center", width: "100%" }}>start date</strong>,
      selector: row => <div style={{ textAlign: "center" }}>{row.started_at ? formatDate(row.started_at) : ""}</div>,
    },
    {
      name: <strong style={{ fontSize: '18px', textAlign: "center", width: "100%" }}>finshed date</strong>,
      selector: row => <div style={{ textAlign: "center" }}>{row.finished_at ? formatDate(row.finished_at) : ""}</div>,
    },
    {
      name: <strong style={{ fontSize: '18px', textAlign: "center", width: "100%" }}>total in po</strong>,
      selector: row => <div style={{ textAlign: "center" }}>{row.amount}</div>,
    },
    {
      name: <strong style={{ fontSize: '18px', textAlign: "center", width: "100%" }}>progress</strong>,
      selector: row => <div style={{ textAlign: "center" }}>{row.test_progress_statuses ? row.test_progress_statuses.length - row.passed_count - row.failed_count : 0}</div>,
    },
    {
      name: <strong style={{ fontSize: '18px', textAlign: "center", width: "100%" }}>Action</strong>,
      selector: row => <div style={{ textAlign: "left" }}>{row.action}</div>,
    },
  ];

  const handleChange = ({ selectedRows }) => {
    // You can set state or dispatch with something like Redux so we can use the retrieved data
    //console.log('Selected Rows: ', selectedRows);
  };
  const paginationComponentOptions = {
    selectAllRowsItem: true,
    selectAllRowsItemText: 'ALL',
  };

  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = React.useState(
    false
  );
  const filteredItems = props.data.filter(
    item =>
      JSON.stringify(item)
        .toLowerCase()
        .indexOf(filterText.toLowerCase()) !== -1
  );


  const handlePageChange = () => {
    // 这里添加切换页面的逻辑
    window.location.href = "/pos/create";
  };

  const subHeaderComponent = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <FilterComponent
          onFilter={e => setFilterText(e.target.value)}
          onClear={handleClear}
          filterText={filterText}
        />
        <Button onClick={handlePageChange} style={{ marginLeft: '10px' }}>
          Add
        </Button>
      </div>
    );
  }, [filterText, resetPaginationToggle]);

  return (
    <>
      <DataTable
        pagination
        paginationPerPage={10}
        paginationComponentOptions={paginationComponentOptions}
        paginationRowsPerPageOptions={[10, 20, 30]}
        highlightOnHover
        // selectableRows
        columns={columns}
        data={filteredItems}
        onSelectedRowsChange={handleChange}
        subHeader
        subHeaderComponent={subHeaderComponent}
      />
    </>
  );
}

export default PosTable;